module.exports = __webpack_public_path__ + "img/996913e.jpg";